import { MergeSchemaData } from '../model';

export function getMergeSourceEntity(data: MergeSchemaData | MergeSchemaData[]) {
    return Array.isArray(data)
        ? data[0]?.entity
        : data?.entity;
}